<template>
  <div :class="{ 'h5-coupon-wrap': isH5, 'coupon-wrap': !isH5 }">
    <div class="left">
      <div class="cont-wrap">
        <p class="price"><span>￥</span>{{ price / 100 }}</p>
        <p class="activity-price">
          券后<span>￥{{ couponInfo.activityPrice }}</span>
        </p>
      </div>
    </div>
    <button
      @click="handleCouponClick"
      class="right"
      v-preventReClick
      :class="received || hasGetcoupon ? 'is-received' : ''"
    >
      <div class="coupon-price">
        <p class="amount" v-if="couponInfo.coupon_type === 1">
          <span class="icon">￥</span>{{ couponInfo.amount }}
        </p>
        <p class="ratio" v-else-if="couponInfo.coupon_type === 2">
          {{ couponInfo.ratio }}折
        </p>
      </div>
      <span class="text" v-if="received || hasGetcoupon">已领取, 去使用</span>
      <span class="text" v-else>立即领券</span>
      <img
        class="arrow-icon"
        src="../../../assets/images/product-details/activity-arrow.png"
        alt=""
      />
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { addCoupon } from "@saas/service-api/src/coupon";
import { isH5 } from "@saas/components/src";
export default {
  props: {
    couponInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    hasGetcoupon: {
      type: Boolean,
      default: false,
    },
    price: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      btnLoding: false,
      received: false,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
  methods: {
    handleCouponClick() {
      if (this.received || this.hasGetcoupon) {
        // 已领取
        this.$emit("signUp");
        console.log(111);
      } else {
        this.receiveCoupon(this.couponInfo.id);
      }
    },
    receiveCoupon(id) {
      if (this.isAuthenticated) {
        if (this.btnLoding) return;
        this.btnLoding = true;
        addCoupon({ id })
          .then((res) => {
            if (res.code === 1) {
              this.received = true;
              this.$message.success("领取成功");
            } else {
              this.$message.error(res.message);
            }
            this.btnLoding = false;
          })
          .catch(() => {
            this.btnLoding = false;
          });
      } else {
        // 未登录
        this.$emit("jumpLoginPage");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-wrap {
  display: flex;
  align-items: center;
  width: 353px;
  height: 56px;
  background: url("../../../assets/images/product-details/coupon-bg.png");
  background-size: 100% 100%;
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    .cont-wrap {
      width: 100%;
      display: flex;
      align-items: center;
    }
    .price {
      margin-right: 8px;
      margin-left: 10px;
      font-weight: 600;
      color: #ffffff;
      font-size: 20px;
      font-family: AvenirLTPro !important;
      span {
        font-size: 12px;
      }
    }
    .activity-price {
      font-family: AvenirLTPro !important;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 3px;
      height: 24px;
      font-weight: 600;
      font-size: 12px;
      color: #ff4067;
      line-height: 16px;
    }
  }
  .right {
    position: relative;
    color: #ff397c;
    width: 144px;
    position: relative;
    top: 1px;
    // .coupon-price {
    //   position: relative;
    //   top: 4px;
    // }
    .amount {
      font-size: 20px;
      line-height: 1;
      font-weight: 600;
    }
    .ratio {
      font-size: 20px;
      font-weight: 600;
      line-height: 1;
      margin-bottom: 1px;
    }
    .icon {
      font-size: 10px;
    }
    .text {
      line-height: 1;
      font-weight: 500;
      font-size: 12px;
    }
    .arrow-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 6px;
      width: 16px;
      height: 16px;
    }
  }
  .is-received .coupon-price {
    color: #fd93b7;
  }
}

.h5-coupon-wrap {
  display: flex;
  align-items: center;
  width: 9.36rem;
  height: 1.49rem;
  background: url("../../../assets/images/product-details/coupon-bg.png");
  background-size: 100% 100%;
  margin-bottom: 0.35rem;
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    .cont-wrap {
      width: 100%;
      display: flex;
      align-items: center;
    }
    .price {
      margin-right: 0.2rem;
      margin-left: 0.21rem;
      font-weight: 600;
      color: #ffffff;
      font-size: 0.53rem;
      span {
        font-size: 0.4rem;
      }
    }
    .activity-price {
      background: #ffffff;
      border-radius: 0.21rem;
      border: 0.03rem solid #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0.11rem;
      height: 0.64rem;
      font-weight: 500;
      font-size: 0.29rem;
      color: #ff4067;
    }
  }
  .right {
    position: relative;
    color: #ff397c;
    width: 3.79rem;
    position: relative;
    top: 1px;
    .amount {
      font-size: 0.53rem;
      font-weight: 600;
      line-height: 1;
    }
    .ratio {
      font-size: 0.53rem;
      font-weight: 600;
      line-height: 1;
      margin-bottom: 1px;
    }
    .icon {
      font-size: 0.27rem;
    }
    .text {
      line-height: 1;
      font-weight: 500;
      font-size: 0.32rem;
    }
    .arrow-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0.08rem;
      width: 0.43rem;
      height: 0.43rem;
    }
  }
  .is-received .coupon-price {
    color: #fd93b7;
  }
}
</style>
